/** Calls `fn` about once a second, even in background tabs. Falls back to setInterval. */
export function startHeartbeat(fn: () => void): void {
  try {
    const w = new Worker(new URL('./ticker.worker.ts', import.meta.url), { type: 'module' });
    w.onmessage = () => fn();
    w.onerror = () => {
      w.terminate();
      setInterval(fn, 1000);
    };
    w.postMessage('start');
  } catch {
    setInterval(fn, 1000);
  }
}
